import { render, staticRenderFns } from "./NoticeIconView.vue?vue&type=template&id=a31c966e&scoped=true&"
import script from "./NoticeIconView.vue?vue&type=script&lang=js&"
export * from "./NoticeIconView.vue?vue&type=script&lang=js&"
import style0 from "./NoticeIconView.vue?vue&type=style&index=0&id=a31c966e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31c966e",
  null
  
)

export default component.exports